import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchIncidents, raiseIncident, patchIncident, confirmIncidentContainment } from '../../services/api/incidentService';

export const loadIncidents = createAsyncThunk('incidents/load', async () => fetchIncidents());

export const createNewIncident = createAsyncThunk('incidents/create', async (payload) => raiseIncident(payload));

export const updateIncidentRecord = createAsyncThunk(
  'incidents/update',
  async ({ id, changes }) => patchIncident(id, changes)
);


export const confirmContainment = createAsyncThunk(
  'incidents/confirmContainment',
  async ({ id, evidence }) => confirmIncidentContainment(id, evidence)
);
const incidentsSlice = createSlice({
  name: 'incidents',
  initialState: { status: 'idle', error: null, items: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadIncidents.pending, (state) => { state.status = 'loading'; })
      .addCase(loadIncidents.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(loadIncidents.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(createNewIncident.fulfilled, (state, action) => {
        state.items.unshift(action.payload);
      })
      .addCase(updateIncidentRecord.fulfilled, (state, action) => {
        const item = state.items.find((i) => i.id === action.payload.id);
        if (item) Object.assign(item, action.payload);
      })
      .addCase(confirmContainment.fulfilled, (state, action) => {
        const item = state.items.find((i) => i.id === action.payload.id);
        if (item) Object.assign(item, action.payload);
      });
  }
});

export default incidentsSlice.reducer;
